import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Longest greeting the bar can seat beside the logo.
 *
 * The bar is one row of fixed height holding the menu button, the greeting and the logo. At the
 * common 360px width that leaves the greeting roughly 126px, or about fifteen characters of the
 * 16px semibold face. Past that it is dropped whole rather than cut: a name sliced mid-word
 * reads as a bug, where its absence reads as nothing at all.
 *
 * The limit is on the rendered string, not on the name, because the name is not all that has to
 * fit — the greeting wraps it, and by a different amount per language (`Hola ` against
 * `Hello `). Measured on the name alone, English would overrun the width Spanish was sized for.
 */
const MAX_GREETING_LENGTH = 15;


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent {
  @Input() toolbarTitle = '';
  @Input() showSideBarToggler: boolean = true;
  @Input() userName?: string;
  @Input() sideBarOpen: boolean = false;
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  private readonly translate = inject(TranslateService);

  /** The greeting to show, or null when there is no name or it does not fit. */
  get greeting(): string | null {
    const name = this.userName?.trim();
    if (!name) return null;

    const greeting: string = this.translate.instant('components.home.welcome', { name });
    return greeting.length <= MAX_GREETING_LENGTH ? greeting : null;
  }

  constructor() {}

  sideBarToggler(): void {
    this.toggleSideBarForMe.emit();
  }
}
